var module = angular.module('octopusApp.configuration');

module.controller('ConfigurationIndexController', function($scope, busy, octopusRepository, octopusPermissionSet, $location) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.currentTab = 'teams';
  $scope.checklist = [];

  octopusPermissionSet.firstAuthorized(["AdministerSystem", "AuditView", "TeamView"]).then(function (p) {
    switch (p) {
      case "AdministerSystem":
        load();
        break;
      case "AuditView":
        $location.path('/configuration/audit');
        break;
      case "TeamView":
        $location.path('/configuration/teams');
    }
  });

  var load = function() {
    isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status){
      isLoading.promise(octopusRepository.Machines.list().then(function(machines){
        isLoading.promise(octopusRepository.Feeds.list().then(function(feeds){
          isLoading.promise(octopusRepository.Projects.list().then(function(projects){
            isLoading.promise(octopusRepository.Users.list().then(function(users){
              $scope.status = status;
              $scope.checklist.push({ completed: machines.Items.length > 0, html: 'Create <a href="#/environments">environments and deployment targets</a>' });
              $scope.checklist.push({ completed: feeds.Items.length > 0, html: 'Add <a href="#/library/feeds">NuGet feeds</a> containing application packages' });
              $scope.checklist.push({ completed: projects.Items.length > 0, html: 'Create some <a href="#/projects">projects</a> to deploy' });
              $scope.checklist.push({ completed: users.Items.length > 1, html: 'Invite some <a href="#/configuration/users">users</a>' });
            }));
          }));
        }));
      }));
    }));
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/overview/configuration_index_controller.js
// module id = 396
// module chunks = 1